<template>
  <div>
    <div :class="groupClass">
      <label :class="lableClass" :for="name">
        <slot>{{ title }}</slot>
        <span v-if="form?.customer?.memo">
          <font-awesome-icon
            v-tooltip="{
              content: form?.customer?.memo.replace(/\n/g, '<br>'),
              classes: ['customer-memo-theme'],
            }"
            :icon="['fal', 'comment-alt-exclamation']"
            class="text-primary ml-1 text-16 cursor"
          />
        </span>
      </label>

      <div :class="fieldClass" class="no-min-width">
        <!--Special Part Starts-->
        <multiselect
          :custom-label="fullname"
          :disabled="readonly"
          :internal-search="false"
          :limit="3"
          :limit-text="limitText"
          :loading="!ready"
          :options="options"
          :options-limit="200"
          :searchable="true"
          :show-labels="false"
          :value="value"
          label="email"
          placeholder="Type to search"
          track-by="id"
          @input="update"
          @search-change="asyncFind"
        >
          <template #noResult>
            <slot name="no-result">Oops! No result found.</slot>
          </template>
        </multiselect>
        <!--Special Part Ends-->

        <div
          v-if="form && form.errors.has(errorId)"
          class="invalid-feedback"
          v-text="form.errors.get(errorId)"
        ></div>
        <slot name="note"></slot>
      </div>

      <div :class="extraSlotClass">
        <slot name="extra">
          <button
            v-if="showResetButton"
            class="btn btn-danger"
            type="button"
            @click.prevent="resetCustomer()"
          >
            <font-awesome-icon :icon="['fal', 'times']" />
          </button>
        </slot>
      </div>
    </div>

    <!--Special Part Starts-->
    <!--Special Part Ends-->
  </div>
</template>

<script type="text/babel">
import debounce from "debounce";
import BaseComponent from "./BaseComponent.vue";

export default {
  extends: BaseComponent,

  props: {
    type: {
      default: null,
    },
    showResetButton: {
      type: Boolean,
      required: false,
      default: false,
    },
    readonly: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  methods: {
    resetCustomer() {
      if (this.form) {
        this.form.errors.clear(this.errorId);
      }

      this.$emit("change", null);
    },

    fullname(customer) {
      if (this.$lodash.get(customer, "is_company")) {
        return this.$lodash.get(customer, "company_name", "NO COMPANY NAME");
      }

      return this.$lodash.get(customer, "primary_contact.name");
    },

    limitText(count) {
      return `and ${count} other customers`;
    },

    /* eslint-disable func-names */
    asyncFind: debounce(function (query) {
      if (query.length < 2) {
        return;
      }

      this.ready = false;

      if (this.form) {
        this.form.errors.clear(this.errorId);
      }

      let typeQuery = "";
      if (this.type) {
        typeQuery = `&type=${this.type}`;
      }

      this.$http
        .get(`/customers?search=${query}&limit=200${typeQuery}&with_recent_notes=true`)
        .then((response) => {
          this.options = response.body.data;
          this.ready = true;
        });
    }, 500),

    update(object) {
      if (object !== undefined && object !== null) {
        this.form[this.name] = object.id;
      }

      if (this.form) {
        this.form.errors.clear(this.errorId);
      }

      this.$emit("change", object);
    },
  },
};
</script>
